

import { computed, ref } from 'vue'
import AuthRepository from '@/services/AuthRepository'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {Register} from "../models/register";
import {useStore} from "vuex";
import {RegisterUser} from "@/models/registerUser";
import {AccountPermission} from "@/models/accountPermission";
import {DichVuCreate} from "@/models/dichVuCreate";
import {DichVu} from "@/models/dichVu";
import moment from 'moment';
import {FilterMatchMode} from "primevue/api";
import {LieuTrinhCreate} from "@/models/lieuTrinhCreate";
import {LieuTrinh} from "@/models/lieuTrinh";
import {SanPhamCreate} from "@/models/sanPhamCreate";
import {SanPham} from "@/models/sanPham";
import {KhachHangCreate} from "@/models/khachHangCreate";
import {KhachHang} from "@/models/khachHang";
import {ThanhPhan} from "@/models/thanhPhan";
import { useConfirm } from "primevue/useconfirm";
import {HoaDonCreate} from "@/models/hoaDonCreate";
import {HoaDon} from "@/models/hoaDon";
import {HoaDonDetail} from "@/models/hoaDonDetail";
import {DoanhThu} from "@/models/doanhThu";
import {LichSuLieuTrinh} from "@/models/lichSuLieuTrinh";
import {ThucHienLieuTrinhCreate} from "@/models/thucHienLieuTrinhCreate";
import {NotificationMessage} from "@/models/notificationMessage";


export default {

  setup(){
    const confirm = useConfirm();
    const router = useRouter();
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const message = ref({} as NotificationMessage);

    if (!!!store.state.token) {
      router.push({ name: "home" });
    }

    const getNotification = () => {
      AuthRepository.getNotification()
          .then((response) => {
            message.value = response.data;
            if (message.value.message.length < 1)
            {
              message.value.message = '';
            }
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }
    getNotification();


    return {
      error,
      message,
    }
  }
}

